import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useParams } from 'react-router-dom';
import { useTemplateEditorState } from '../../context/UseTemplateEditorContext';
import { saveOnsiteTemplate, saveTemplate } from '../../utils/queries';

export const useTemplateEditorSaveModal = () => {
  const { t } = useTranslation(['designs']);
  const { siteId, id: templateId } = useParams<{ siteId: string; id: string }>();
  const { mutate } = useMutation(saveTemplate);
  const { mutate: onsiteTemplateSaveMutate } = useMutation(saveOnsiteTemplate);
  const { template, language, languageStatus, onsiteValidationMessage } = useTemplateEditorState();

  return {
    saveModal: (comment: string, onSuccess: () => void, onError: () => void) => {
      if (template.channel !== 'onsite') {
        mutate(
          {
            siteId,
            templateId,
            templateName: template.templateName,
            templateBody: template.template,
            enrichmentConfigIds: template.enrichmentConfigIds,
            language,
            languageStatus,
            comment,
            type: template.type,
            t,
          },
          {
            onSuccess: onSuccess,
            onError: onError,
          },
        );
      } else {
        onsiteTemplateSaveMutate(
          {
            siteId,
            templateId,
            templateName: template.templateName,
            templateBody: template.template,
            enrichmentConfigIds: template.enrichmentConfigIds,
            language,
            languageStatus,
            comment,
            onsiteValidationMessage: onsiteValidationMessage,
            type: template.type,
            t,
          },
          {
            onSuccess: onSuccess,
            onError: onError,
          },
        );
      }
    },
  };
};
